var _circle, _tspan, _tspan2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPinBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.6112mm",
    height: "7.3422mm",
    viewBox: "0 0 4.6112 7.3422",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-339.42 379.86)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426.91,
    cy: -391.4,
    r: 31.915,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    x: 285.88116,
    y: -274.14557,
    fontFamily: "'Century Gothic'",
    fontSize: "18.064px",
    letterSpacing: "4.7625px",
    strokeWidth: 0.094084,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 285.88116,
    y: -274.14557,
    fontFamily: "'Century Gothic'",
    fontSize: "18.064px",
    strokeWidth: 0.094084
  }, "STUDIOS"))), /*#__PURE__*/React.createElement("text", {
    x: 261.30792,
    y: -295.97427,
    fontFamily: "'Century Gothic'",
    fontSize: "50.8px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 261.30792,
    y: -295.97427,
    fontFamily: "'Century Gothic'",
    fontSize: "50.8px",
    fontWeight: "bold",
    strokeWidth: 0.26458
  }, "O STARS"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m258.72-295.93-16.689-5.4773-10.283 14.24-0.22853-17.564-16.44-5.3795 16.44-5.3782 0.22993-17.564 10.282 14.241c2.1206 2.8917 4.2212 5.7979 6.3228 8.7034z",
    strokeLinecap: "round",
    strokeWidth: 7.8456
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m258.58-296.22-5e-3 -36.729h-5.9899v32.351z",
    stroke: "#000",
    strokeWidth: ".26458px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m236.45-318.64 10 13.404-6.036-1.2784s-3.6147 5.4661-3.6147 5.2016-0.61713-6.6562-0.61713-6.6562l-6.3036-1.9396 6.3036-2.4686z",
    fill: "#7197bd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m444.91-373.41-18.515-6.0766-11.408 15.798 0.0578-19.486-18.55-5.9681 18.551-5.9667-0.0562-19.486 11.407 15.799c2.3527 3.2081 4.6832 6.4323 7.0147 9.6557z",
    strokeLinecap: "round",
    strokeWidth: 8.7041
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m444.76-373.73-6e-3 -40.749h-6.6454v35.891z",
    stroke: "#000",
    strokeWidth: ".29354px"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m420.2-398.59 11.094 14.871-6.6965-1.4182s-4.0102 6.0642-4.0102 5.7708-0.68466-7.3846-0.68466-7.3846l-6.9934-2.1518 6.9934-2.7387z",
    fill: "#7197bd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m571.31-359.45-30.632-10.054-18.875 26.137-0.0149-32.24-30.58-9.8741 30.581-9.8718 0.0175-32.24 18.873 26.139c3.8925 5.3077 7.7482 10.642 11.606 15.975z",
    strokeLinecap: "round",
    strokeWidth: 14.401
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m571.05-359.98-0.01-67.418h-10.995v59.382z",
    stroke: "#000",
    strokeWidth: ".48565px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.43-401.12 18.355 24.603-11.079-2.3465s-6.6348 10.033-6.6348 9.5476c0-0.48546-1.1328-12.218-1.1328-12.218l-11.57-3.5601 11.57-4.5311z",
    fill: "#7197bd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.32,
    cy: -377.88,
    r: 1.4056,
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.32-377.92v4.6441",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.72,
    cy: -377.56,
    r: 1.4056,
    stroke: "#000",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.72-377.59v4.6441",
    stroke: "#000",
    strokeWidth: 0.86
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinBlack);
export default __webpack_public_path__ + "static/media/locationPinBlack.89420c8e4ee597b628985828f507ce21.svg";
export { ForwardRef as ReactComponent };